import React, { useEffect, useMemo, useRef } from 'react';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import './GetRates.css';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import SendIcon from '@mui/icons-material/Send';
import {
  GetQuote,
  GetQuoteDetail,
  LogTLShipperResponse,
  ResendQuote
} from '../../apis/AgencyWithoutAuthHeaders';
import CancelIcon from '@mui/icons-material/Cancel';
import SortIcon from '@mui/icons-material/Sort';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ErrorToast, successToast } from '../../components/Toasts';
import { base_logo_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import { Autocomplete, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Or use another icon if preferred
import { blue, grey, lightBlue } from '@mui/material/colors';
import {
  CalculateDistance,
  CancelTLShipment,
  GetShipmentDetails,
  MarkAsReadMessages,
  TLShipmentHistory,
  UpdateQuoteCarrier
} from '../../apis/Agency';
import FloatingChatSystem from '../FloatingChatBox/FlaotingChatBox';
import { Verified } from '@mui/icons-material';
import { calculateRatePerMile } from '../../widgets/CalculateFunctions';
import { formatNumberWithCommas } from '../../apis/Utils';
import ShipmentDetailsComponent from '../ShipDetailsComponent';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

import HistoryIcon from '@mui/icons-material/History';
import ReactApexChart from 'react-apexcharts';

function TLRatingScreen({
  shipStatus,
  setShipStatus,
  quoteNumber,
  state,
  quoteMode,
  rateType,
  shipmentId,
  previousRowDetails,
  handleViewTLRates,
  TLQuoteId,
  carriers,
  handleListItemClick,
  selectedIndex,
  isLoading,
  ApiFailed,
  DataToShow,
  ApiErrorMessage
}) {
  const history = useHistory();
  const [historicalRatesAnchor, setHistoricalRatesAnchor] = useState(null);
  const [selectedCarrierForHistory, setSelectedCarrierForHistory] =
    useState(null);
  const [historicalRatesData, setHistoricalRatesData] = useState([]);
  const [loadingHistoricalRates, setLoadingHistoricalRates] = useState(false);

  const fetchHistoricalRates = async carrierData => {
    console.log(shipmentsDetails, 'historical rates API called');
    const zipFrom = shipmentsDetails[0]?.zip || '';
    const zipTo = shipmentsDetails[shipmentsDetails.length - 1]?.zip || '';

    TLShipmentHistory(carrierData.carrierId || 0, zipFrom, zipTo)
      .then(res => {
        res.status === 200 && console.log(res, 'historical rates data');
        const filteredTLRates = res.data.data.filter(
          items =>
            items.shipmentCharges !== 0 && items.shipmentStatus === 'Delivered'
        );
        setHistoricalRatesData(filteredTLRates);
        // if (res.data.data.length === 0) {
        //   ErrorToast('No historical rates data found for this carrier.');
        // }
      })
      .catch(err => {
        ErrorToast('Failed to fetch historical rates data.');
        console.log(err, 'historical rates API error');
      });
  };
  const handleOpenHistoricalRates = async (e, carrierData) => {
    e.stopPropagation();
    setSelectedCarrierForHistory(carrierData);
    setHistoricalRatesAnchor(true);
    // const dummyData = generateDummyHistoricalData(carrierData);
    // setHistoricalRatesData(dummyData);

    try {
      setLoadingHistoricalRates(true);
      // Fetch historical rates from your API
      const response = await fetchHistoricalRates(carrierData); // Adjust based on your API
      // setHistoricalRatesData(response.data || []);
    } catch (error) {
      console.error('Error fetching historical rates:', error);
    } finally {
      setTimeout(() => {
        setLoadingHistoricalRates(false);
      }, 2000);
    }
  };

  const handleCloseHistoricalRates = () => {
    setHistoricalRatesAnchor(null);
    setSelectedCarrierForHistory(null);
    setHistoricalRatesData([]);
  };

  const [negotitateRate, setNegotiateRate] = useState(false);
  const [carrierName, setCarrierName] = useState('');
  const [carrierLogo, setCarrierLogo] = useState('');

  // const [userInput, setUserInput] = useState('');
  const [userInput, setUserInput] = useState({});

  const [searchCarrier, setSearchCarrier] = useState('All Carriers');

  const [userInputArray, setUserInputArray] = useState([]);
  const [showInputValue, setShowInputValue] = useState(false);
  const [shipperSessionId, setShipperSessionId] = useState('');
  const [openChats, setOpenChats] = useState({});
  const [chatMinimized, setChatMinimized] = useState({});
  const [chatOrder, setChatOrder] = useState([]);
  const [htmlApiRes, setHtmlApiRes] = useState('');
  const [shipperApiMsgs, setShipperApiMsgs] = useState([]);
  const [carrierApiMsgs, setCarrierApiMsgs] = useState([]);
  const [filteredCarriers, setFilteredCarriers] = useState([]);
  const [sortValue, setSortValue] = useState(0);
  const [sortKey, setSortKey] = useState('price');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [distanceMiles, setDistanceMiles] = useState(0);
  const [calDistanceValue, setCalDistanceValue] = useState(0);
  const [cancelShipLoad, setCancelShipLoad] = useState(false);
  const [cancelShipDialog, setCancelShipDialog] = useState(false);
  const [cancelShipData, setCancelShipData] = useState(null);
  const [shipmentsDetails, setShipmentsDetails] = useState(
    previousRowDetails?.details ? previousRowDetails?.details : []
  );
  const [selectCarrier, setSelectCarrier] = useState({});
  const [sendQuoteToAll, setSendQuoteToAll] = useState(false);
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setCancelShipDialog(false);
    setReason('');
  };

  const handleConfirm = () => {
    setCancelShipLoad(true);
    const obj = {
      shipmentId: previousRowDetails?.shipmentId ?? 0,
      remarks: reason ?? '',
      pickupDate: cancelShipData.quotePickupDate ?? '',
      deliveryDate: cancelShipData.deliveryDate ?? '',
      action: 0
    };
    CancelTLShipment(obj)
      .then(res => {
        res.status === 200 && successToast('This Shipment Has Been Cancelled');
        if (sortedItems.length === 1) {
          history.push('/quick-quote');
        }
        handleClose();

        handleListItemClick('', '', '');
        setTimeout(() => {
          setCancelShipLoad(false);
          setShipStatus('Cancelled');
        }, 3000);
      })
      .catch(err => {
        ErrorToast(`Cancel Shipment API failed due to ${err.message}`);
        setCancelShipLoad(false);
        handleClose();
      });
  };

  const customSort = (a, b) => {
    const order = ['RESPONDED', 'PENDING'];
    const indexA = order.indexOf(a.carrierResponseStatus);
    const indexB = order.indexOf(b.carrierResponseStatus);
    return indexB - indexA;
  };
  useEffect(() => {
    // let tempcarriers = carriers.sort(
    //   (a, b) => a.active.quoteValue - b.active.quoteValue
    // );
    const sortedArray = carriers.sort(customSort);
    setFilteredCarriers(sortedArray);
  }, [carriers]);

  useEffect(() => {
    const idToUse = shipmentId;
    if (!idToUse) return; // Do nothing if no ID available yet

    GetShipmentDetails(idToUse)
      .then(res => {
        if (res.status === 200) {
          const ApiZipFrom = res?.data?.data[0]?.zip;
          const ApiZipTo = res?.data?.data[res?.data?.data?.length - 1]?.zip;
          if (ApiZipFrom !== '' && ApiZipTo !== '') {
            CalculateDistance(ApiZipFrom, ApiZipTo)
              .then(res => {
                setDistanceMiles(
                  res?.data?.rows[0]?.elements[0]?.distance?.text
                );
                setCalDistanceValue(
                  res?.data?.rows[0]?.elements[0]?.distance?.value
                );
              })
              .catch(err => console.log(err, 'Distance Api Error'));
          }
          setShipmentsDetails(res.data.data);
        }
      })
      .catch(err => ErrorToast('Get Shipment Details API failed'));
  }, [shipmentId]);

  const { carrierOptions, totalPending, totalResponded } = useMemo(() => {
    let pending = 0;
    let responded = 0;

    const names = carriers?.reduce((acc, carrier) => {
      const name = carrier?.name || carrier?.carrierName;

      const status = carrier?.carrierResponseStatus?.toLowerCase?.();
      if (status === 'pending') {
        pending += 1;
      } else {
        responded += 1;
      }

      if (typeof name === 'string' && name.trim() !== '') {
        acc.push(name);
      }

      return acc;
    }, []);

    const uniqueNames = [...new Set(names)];

    return {
      carrierOptions: ['All Carriers', ...uniqueNames],
      totalPending: pending,
      totalResponded: responded
    };
  }, [carriers]);

  // useEffect(() => {
  //   console.log(totalResponded, totalPending, 'res.data.data');
  //   if (
  //     // totalPending !== 0 &&
  //     totalResponded > 0 &&
  //     totalResponded > totalPending
  //   ) {
  //     sound.play();
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }, [totalPending, totalResponded]);
  const applyStatusSort = (a, b) => {
    if (
      a.carrierResponseStatus === 'PENDING' &&
      b.carrierResponseStatus !== 'PENDING'
    ) {
      return 1; // "pending" item comes last
    } else if (
      a.carrierResponseStatus !== 'PENDING' &&
      b.carrierResponseStatus === 'PENDING'
    ) {
      return -1; // "pending" item comes first
    } else {
      return 0; // No change in order for other statuses
    }
  };
  const applySort = (rowA, rowB) => {
    switch (sortKey) {
      case 'price':
        return sortOrder === 'ASC'
          ? rowA.quoteValue - rowB.quoteValue
          : rowB.quoteValue - rowA.quoteValue;
      case 'days':
        const dateA = new Date(rowA.deliveryDate);
        const dateB = new Date(rowB.deliveryDate);

        const daysA = isNaN(dateA.getTime()) ? 9999 : dateA.getTime();
        const daysB = isNaN(dateB.getTime()) ? 9999 : dateB.getTime();

        return sortOrder === 'ASC' ? daysA - daysB : daysB - daysA;
      case 'name':
        return sortOrder === 'ASC'
          ? rowA.carrierName.localeCompare(rowB.carrierName)
          : rowB.carrierName.localeCompare(rowA.carrierName);
      default:
        return 0; // Default case: no sorting
    }
  };

  const ratingCarriers = useMemo(() => {
    const carrierList =
      !searchCarrier || searchCarrier === 'All Carriers'
        ? carriers
        : carriers.filter(carrier =>
            (carrier?.name || carrier?.carrierName || '')
              .toLowerCase()
              .includes(searchCarrier.toLowerCase())
          );

    const merged = carrierList.map(carrier => {
      if (carrier?.carrierResponseStatus?.toUpperCase() !== 'PENDING') {
        const chatDetails = shipperApiMsgs?.filter(
          msg => msg.sessionId === carrier.sessionId
        );
        return {
          ...carrier,
          chatDetails: chatDetails.length > 0 ? chatDetails : null
        };
      }
      return carrier;
    });
    return merged;
  }, [searchCarrier, carriers, shipperApiMsgs]);

  useEffect(() => {
    const sortedItems = filteredCarriers.sort((a, b) => {
      if (
        a.carrierResponseStatus === 'PENDING' &&
        b.carrierResponseStatus !== 'PENDING'
      ) {
        return 1; // "pending" item comes last
      } else if (
        a.carrierResponseStatus !== 'PENDING' &&
        b.carrierResponseStatus === 'PENDING'
      ) {
        return -1; // "pending" item comes first
      } else {
        return 0; // No change in order for other statuses
      }
    });
    setFilteredCarriers(sortedItems);
  }, [filteredCarriers]);
  const sortedItems = ratingCarriers.sort(applySort).sort(applyStatusSort);
  const soundPlayedRef = useRef(false);
  const handleClick = e => {
    e.preventDefault();
    // Perform your desired action on item click
    // console.log('Item clicked:', item);
  };
  const handleSuccessResponse = (apiRes, action) => {
    // if (
    //   apiRes.data.data.details.some(
    //     element =>
    //       element.actionByFlag.toLowerCase() === 'carrier' && !element.isRead
    //   ) &&
    //   !soundPlayedRef.current
    // ) {
    //   sound.play();
    //   soundPlayedRef.current = true; // mark as played
    // }
    action === 'resend' &&
      successToast('The email has been successfully resent.');
    const shipperData = apiRes.data.data.details.filter(
      items => items.actionByFlag.toLowerCase() === 'shipper'
    );
    const carrierData = apiRes.data.data.details.filter(
      items => items.actionByFlag.toLowerCase() === 'carrier'
    );
    // setHtmlApiRes(apiRes.data.data);
    // carrierMsgsRef.current = carrierData;
    // shipperMsgsRef.current = apiRes.data.data.details;
    setShipperApiMsgs(prev => {
      const newMsgs = Array.isArray(apiRes.data.data.details)
        ? apiRes.data.data.details
        : [apiRes.data.data.details];

      const allMsgs = [...prev];

      newMsgs.forEach(newMsg => {
        const existingIndex = allMsgs.findIndex(
          msg =>
            msg.sessionId === newMsg.sessionId &&
            msg.action === newMsg.action &&
            msg.actionData === newMsg.actionData &&
            msg.date === newMsg.date
        );

        if (existingIndex !== -1) {
          // 🔄 Update existing message (replace with latest from API)
          allMsgs[existingIndex] = newMsg;
        } else {
          // ➕ Add new one
          allMsgs.push(newMsg);
        }
      });

      return allMsgs;
    });

    // setShipperApiMsgs(prev => {
    //   const newMsgs = Array.isArray(apiRes.data.data.details)
    //     ? apiRes.data.data.details
    //     : [apiRes.data.data.details];

    //   return [...prev, ...newMsgs];
    // });

    setCarrierApiMsgs(prev => {
      const newMsgs = Array.isArray(carrierData) ? carrierData : [carrierData];

      const allMsgs = [...prev];

      newMsgs.forEach(newMsg => {
        const existingIndex = allMsgs.findIndex(
          msg =>
            msg.sessionId === newMsg.sessionId &&
            msg.action === newMsg.action &&
            msg.actionData === newMsg.actionData &&
            msg.date === newMsg.date
        );

        if (existingIndex === -1) {
          // Not found → push
          allMsgs.push(newMsg);
        } else {
          // Found → replace with latest
          allMsgs[existingIndex] = newMsg;
        }
      });

      return allMsgs;
    });

    // setHtmlApiRes(apiRes.data.data.actionData);
    // setActionByName(apiRes.data.data.actionBy);
  };
  const ShipperQuoteReqHandler = (shipperSessionId, action) => {
    GetQuoteDetail(shipperSessionId)
      .then(res => res.status === 200 && handleSuccessResponse(res, action))
      .catch(err => console.log(err, 'QuoteTLErr------>>>.'));
  };

  const handleMarkAsReadMsgs = (items, status) => {
    const readMsgsArr = items?.chatDetails
      ?.filter(items => items.actionByFlag === 'CARRIER')
      ?.map(items => items.messageId);
    MarkAsReadMessages(readMsgsArr?.map(Number))
      .then(res => {
        if (res.status === 200) {
          console.log((res, 'success of mark as read msg'));
          soundPlayedRef.current = false;
        }
        console.log(res, 'Read Msgs Success');
      })
      .catch(err => console.log(err, 'Read msgs error'));
  };

  const handleShareRatesWithWysis = items => {
    if (items.length > 1) {
      const shareAllRatesObj = {
        id: 0,
        ids: [],
        makePublic: true
      };
      for (let i = 0; i < items.length; i++) {
        const id = items[i].id;
        shareAllRatesObj.ids.push(id);
      }

      UpdateQuoteCarrier(shareAllRatesObj)
        .then(
          res =>
            res.status === 200 &&
            successToast('All Carrier Rates successfully shared with Wysis.')
        )
        .catch(err => {
          ErrorToast('Failed to share All Carrier Rates with Wysis.');
          console.log(err, 'Share rates with Wysis API error');
        });
    } else {
      const shareSoloRateObj = {
        id: items.id ?? 0,
        ids: [],
        makePublic: true
      };
      UpdateQuoteCarrier(shareSoloRateObj)
        .then(
          res =>
            res.status === 200 &&
            successToast('Rate successfully shared with Wysis.')
        )
        .catch(err => {
          ErrorToast('Failed to share rates with Wysis');
          console.log(err, 'Share rates with Wysis API error');
        });
    }
  };

  const handleOpenChat = (sessionId, status, items) => {
    setChatOrder(prev => {
      let updated = [...prev];

      // If chat already exists, remove it first (to re-add at end)
      updated = updated.filter(id => id !== sessionId);

      // Add to rightmost
      updated.push(sessionId);

      // Keep only last 3
      if (updated.length > 3) {
        updated = updated.slice(-3);
      }

      return updated;
    });
    handleMarkAsReadMsgs(items, status);
    setChatMinimized(prev => ({
      ...prev,
      [sessionId]: false
    }));
    setOpenChats(prev => ({
      ...prev,
      [sessionId]: status
    }));
  };

  const toggleChatMinimize = (sessionId, carrier) => {
    handleMarkAsReadMsgs(carrier, chatMinimized);
    setChatMinimized(prev => ({
      ...prev,
      [sessionId]: !prev[sessionId]
    }));
  };

  const handleResendQuote = (items, action) => {
    if (action === 'sendToAll') {
      setSendQuoteToAll(true); // just set loading = true

      (async () => {
        for (const element of items) {
          try {
            const res = await ResendQuote(element.sessionId);
            if (res.status === 200) {
              successToast(
                `Email successfully resent to ${
                  element.carrierName || element.sessionId
                }`
              );
              await ShipperQuoteReqHandler(element.sessionId, '');
            } else {
              console.log(`Failed for ${element.sessionId}`, res);
            }
          } catch (err) {
            console.log(err, `Resend failed for ${element.sessionId}`);
          }
        }
        setSendQuoteToAll(false); // hide loader when done
      })();
    } else {
      ResendQuote(items.sessionId)
        .then(
          res =>
            res.status === 200 &&
            ShipperQuoteReqHandler(items.sessionId, 'resend')
        )
        .catch(err => console.log(err, 'Resend Err---->>>>'));
    }
  };

  const handleNegotiateRate = (e, items, action) => {
    setShipperSessionId(items.sessionId);
    if (
      (items?.carrierResponseStatus?.toLowerCase() === 'responded' ||
        items?.carrierResponseStatus?.toLowerCase() === 'accepted') &&
      action === 'update_chat'
    ) {
      ShipperQuoteReqHandler(items.sessionId);
    }
    if (action === 'Resend') {
      handleResendQuote(items);
    }

    setCarrierName(items?.carrierName);
    setCarrierLogo(items?.logo);
    if (
      action === 'view_chat' ||
      items?.carrierResponseStatus?.toLowerCase() === 'responded' ||
      items?.carrierResponseStatus?.toLowerCase() === 'accepted'
    ) {
      setNegotiateRate(true);
    }
  };

  const handleUserInput = (id, input) => {
    // setUserInput(input);
    setUserInput(prev => ({
      ...prev,
      [id]: input
    }));
  };

  const handleChatRequestApi = shipperSessionId => {
    const chatObj = {
      sessionId: shipperSessionId,
      charges: 0,
      pickupNumber: '',
      pickupDate: '',
      estimatedDeliveryDate: '',
      comments: userInput[shipperSessionId]
    };
    LogTLShipperResponse(chatObj)
      .then(
        res => res.status === 200 && ShipperQuoteReqHandler(shipperSessionId)
      )
      .catch(err => ErrorToast(err?.message));
  };

  const handleShowUserInputMsgs = id => {
    setShowInputValue(true);
    getCurrentDateTime();
    const message = userInput[id];
    if (!message?.trim()) return;

    // Send your message logic here...

    // Clear input only for that session
    setUserInput(prev => ({
      ...prev,
      [id]: ''
    }));
    if (userInput !== '') {
      handleChatRequestApi(id);
    }
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleShowUserInputMsgs();
    }
  };
  const bottomRef = useRef(null);

  const scrollToBottom = () => {
    // alert('scrollled');
    bottomRef.current &&
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    // Scroll to the bottom whenever userInputArray is updated
    scrollToBottom();
  }, [shipperApiMsgs, negotitateRate]);

  const getCurrentDateTime = (() => {
    let initialTimestamp = null;

    return () => {
      if (!initialTimestamp) {
        initialTimestamp = new Date();
        let temp = [...userInputArray];
        temp.push({ timeStamp: initialTimestamp, msg: userInput });
        // temp.push({ msg: userInput });
        setUserInputArray(temp);
      }

      const now = new Date();
      const diff = now - initialTimestamp;

      const daysOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'July',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ];

      const dayName = daysOfWeek[initialTimestamp.getDay()];
      const monthName = months[initialTimestamp.getMonth()];
      const day = initialTimestamp.getDate();
      const year = initialTimestamp.getFullYear();

      const hours = initialTimestamp.getHours();
      const minutes = initialTimestamp.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      const formattedTime = `${hours % 12 || 12}:${
        minutes < 10 ? '0' : ''
      }${minutes} ${ampm}`;
      let temp = [...userInputArray];
      temp.push({
        timeStamp: ` ${monthName} ${day}, ${year} ${formattedTime}`,
        msg: userInput
      });
      // temp.push({ msg: userInput });
      setUserInputArray(temp);
      // return ` ${monthName} ${day}, ${year} ${formattedTime}`;
    };
  })();
  const isMobile = useIsMobile();
  const detailsList =
    previousRowDetails?.details || previousRowDetails?.pickupLineItems || [];
  function formatDateTime(dateTime) {
    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ];
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const dayName = daysOfWeek[dateTime.getDay()];
    const monthName = months[dateTime.getMonth()];
    const day = dateTime.getDate();
    const year = dateTime.getFullYear();

    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    const formattedTime = `${hours % 12 || 12}:${
      minutes < 10 ? '0' : ''
    }${minutes} ${ampm}`;

    return `${dayName}, ${monthName} ${day}, ${year} ${formattedTime}`;
  }

  const handleSynchRatesRequest = () => {
    GetQuote(TLQuoteId)
      .then(res => {
        res.status === 200 && handleViewTLRates(res.data.data);
        res.data.data.quoteCarriers.forEach((element, i) => {
          if (element.carrierResponseStatus !== 'PENDING') {
            ShipperQuoteReqHandler(element.sessionId);
          }
        });
      })
      .catch(err => console.log(err, 'TL quote Err----->>>>'));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (TLQuoteId && historicalRatesAnchor === null) {
        handleSynchRatesRequest();
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [TLQuoteId, historicalRatesAnchor]);

  const handleSortToggle = () => {
    setSortOrder(prevOrder => (prevOrder === 'ASC' ? 'DESC' : 'ASC'));
  };
  const handleSortValueChange = (event, newValue) => {
    setSortValue(newValue);
  };

  const removeTableCss = finalRes => {
    const regexPattern = /<style[^>]*>([\s\S]*?)<\/style>/gi;

    // Remove table styles including borders
    const updatedHtml = finalRes.replace(regexPattern, (match, styles) => {
      const stylesWithoutTable = styles.replace(
        /(?:table|td|th)\s*\{[^}]*\}/gi,
        ''
      );
      return `<style>${stylesWithoutTable} table { font-size: 12px; } td { padding: 5px; }</style>`;
    });
    return updatedHtml;
  };

  const handleCorresHistory = apiRes => {
    // Regex pattern to capture and replace font-size in table styles
    const fontSizeToUpdate = removeTableCss(apiRes);

    return fontSizeToUpdate;

    // removeTableCss(updatedHtml);
  };

  const totalPieces = shipmentsDetails.reduce(
    (sum, item) =>
      sum + Number(item.itemType === 'Pickup' ? item.units || 0 : 0),
    0
  );

  const pickups = shipmentsDetails.filter(item => item.itemType === 'Pickup');
  const deliveries = shipmentsDetails.filter(
    item => item.itemType === 'Delivery'
  );

  const groupedPickupDetails = pickups.reduce((acc, item) => {
    const key = `${item.address}-${item.city}-${item.state}-${item.zip}-${item.country}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const groupedDeliveryDetails = deliveries.reduce((acc, item) => {
    const key = `${item.address}-${item.city}-${item.state}-${item.zip}-${item.country}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const handleCancelShip = (e, items) => {
    setCancelShipDialog(true);
    setCancelShipData(items);
  };

  const generateDummyHistoricalData = carrierData => {
    const rates = [];
    const baseRate = carrierData?.quoteValue || 1000;
    const baseDate = new Date();

    // Generate 6 months of historical data
    for (let i = 5; i >= 0; i--) {
      const date = new Date(baseDate);
      date.setMonth(date.getMonth() - i);

      // Random variation in rates (±20%)
      const variation = Math.random() * 0.4 - 0.2; // -20% to +20%
      const quoteValue = Math.round(baseRate * (1 + variation));

      // Random service types
      const serviceTypes = ['Standard', 'Express', 'Premium', 'Economy'];
      const serviceType =
        serviceTypes[Math.floor(Math.random() * serviceTypes.length)];

      // Random delivery dates (1-10 days from quote date)
      const deliveryDate = new Date(date);
      deliveryDate.setDate(
        deliveryDate.getDate() + Math.floor(Math.random() * 10) + 1
      );

      rates.push({
        id: i,
        quoteDate: date.toISOString(),
        quoteValue: quoteValue,
        serviceType: serviceType,
        deliveryDate: deliveryDate.toISOString(),
        deliveryDays: Math.ceil(
          (new Date(deliveryDate) - new Date(date)) / (1000 * 60 * 60 * 24)
        ),
        ratePerMile: calculateRatePerMile(distanceMiles, quoteValue),
        carrierName: carrierData?.carrierName || 'Carrier',
        isCurrent: i === 5, // Latest one is current
        formattedDate: date.toLocaleDateString('en-US', {
          month: 'short',
          year: 'numeric'
        })
      });
    }

    return rates;
  };

  const prepareChartData = historicalData => {
    const sortedData = [...historicalData].sort(
      (a, b) => new Date(a.quoteDate) - new Date(b.quoteDate)
    );

    return {
      dates: sortedData.map(item => item.formattedDate),
      quoteValues: sortedData.map(item => item.quoteValue),
      ratePerMile: sortedData.map(item => parseFloat(item.ratePerMile)),
      deliveryDates: sortedData.map(item =>
        new Date(item.deliveryDate).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        })
      ),
      carrierNames: sortedData.map(item => item.carrierName),
      serviceTypes: sortedData.map(item => item.serviceType)
    };
  };

  const disableQuoteBtn = sendQuoteToAll || shipStatus === 'Booked';

  return (
    <div>
      {console.log(historicalRatesAnchor, 'historicalRatesAnchor')}
      {/* Add this Dialog component at the end of your main return statement */}
      <Dialog
        open={Boolean(historicalRatesAnchor)}
        onClose={handleCloseHistoricalRates}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle>
          <Grid container alignItems='center' spacing={2}>
            <Grid item>
              <Avatar
                variant='rounded'
                src={
                  selectedCarrierForHistory?.carrierLogo
                    ? base_logo_url + selectedCarrierForHistory.carrierLogo
                    : NoLogo
                }
                sx={{ width: 40, height: 40 }}
              />
            </Grid>
            <Grid item>
              Historical Rates - {selectedCarrierForHistory?.carrierName}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {loadingHistoricalRates ? (
            <Box display='flex' justifyContent='center' p={3}>
              <CircularProgress />
            </Box>
          ) : historicalRatesData.length > 0 ? (
            <Box>
              {/* Summary Statistics */}
              <Paper
                elevation={0}
                sx={{ p: 2, mb: 3, bgcolor: 'primary.50', borderRadius: 2 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant='caption' color='textSecondary'>
                      Average Rate
                    </Typography>
                    <Typography variant='h6' color='primary'>
                      $
                      {formatNumberWithCommas(
                        Math.round(
                          historicalRatesData.reduce(
                            (sum, rate) => sum + (rate.quoteNetCharge || 0),
                            0
                          ) / historicalRatesData.length
                        )
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant='caption' color='textSecondary'>
                      Lowest Rate
                    </Typography>
                    <Typography variant='h6' color='success.main'>
                      $
                      {formatNumberWithCommas(
                        Math.min(
                          ...historicalRatesData.map(
                            rate => rate.quoteNetCharge || 0
                          )
                        )
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant='caption' color='textSecondary'>
                      Highest Rate
                    </Typography>
                    <Typography variant='h6' color='error.main'>
                      $
                      {formatNumberWithCommas(
                        Math.max(
                          ...historicalRatesData.map(
                            rate => rate.quoteNetCharge || 0
                          )
                        )
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Line Chart */}
              <Box sx={{ height: 350, mb: 3 }}>
                <Typography variant='subtitle2' gutterBottom>
                  Historical Rates Trend
                </Typography>

                {(() => {
                  // Prepare chart data from API response
                  const prepareChartData = data => {
                    // Sort by actualDeliveryDate
                    const sortedData = [...data].sort(
                      (a, b) =>
                        new Date(a.actualDeliveryDate) -
                        new Date(b.actualDeliveryDate)
                    );

                    return {
                      quoteValues: sortedData.map(
                        item => item.quoteNetCharge || 0
                      ),
                      deliveryDates: sortedData.map(item =>
                        new Date(item.actualDeliveryDate).toLocaleDateString(
                          'en-US',
                          {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          }
                        )
                      ),
                      carrierNames: sortedData.map(
                        item => item.carrierName || 'Unknown Carrier'
                      ),
                      serviceTypes: sortedData.map(
                        item => item.serviceType || 'Standard'
                      ),
                      quoteDates: sortedData.map(item =>
                        new Date(item.createdOn).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric'
                        })
                      ),
                      // Calculate rate per mile if distance is available
                      ratePerMile: sortedData.map(item => {
                        if (item.shipmentMiles && item.quoteNetCharge) {
                          return parseFloat(
                            (item.quoteNetCharge / item.shipmentMiles).toFixed(
                              2
                            )
                          );
                        }
                        return 0;
                      })
                    };
                  };

                  const chartData = prepareChartData(historicalRatesData);

                  const chartOptions = {
                    chart: {
                      type: 'line',
                      height: 350,
                      zoom: {
                        enabled: false // Disable zoom if you don't want any zoom functionality
                      },
                      toolbar: {
                        show: false // This completely hides the toolbar with all icons
                      }
                    },
                    colors: ['#1976d2'],
                    series: [
                      {
                        name: 'Quote Value ($)',
                        type: 'line',
                        data: chartData.quoteValues
                      }
                    ],
                    xaxis: {
                      categories: chartData.deliveryDates, // Y-axis: Delivery Dates
                      title: {
                        text: 'Delivery Date',
                        style: {
                          fontSize: '12px',
                          fontWeight: 600
                        }
                      },
                      labels: {
                        style: {
                          fontSize: '11px'
                        },
                        rotate: -45,
                        formatter: function (value) {
                          // Format date for better readability
                          return value;
                        }
                      }
                    },
                    yaxis: {
                      title: {
                        text: 'Quote Value ($)',
                        style: {
                          fontSize: '12px',
                          fontWeight: 600
                        }
                      },
                      labels: {
                        formatter: function (value) {
                          return '$' + formatNumberWithCommas(value);
                        },
                        style: {
                          fontSize: '11px'
                        }
                      }
                    },
                    stroke: {
                      width: 3,
                      curve: 'smooth'
                    },
                    markers: {
                      size: 6,
                      hover: {
                        size: 10
                      }
                    },
                    tooltip: {
                      shared: false,
                      intersect: true,
                      custom: function ({
                        series,
                        seriesIndex,
                        dataPointIndex,
                        w
                      }) {
                        const quoteValue = series[0][dataPointIndex];
                        const date = chartData.deliveryDates[dataPointIndex];
                        const carrierName =
                          chartData.carrierNames[dataPointIndex];
                        const serviceType =
                          chartData.serviceTypes[dataPointIndex];
                        const quoteDate = chartData.quoteDates[dataPointIndex];
                        const ratePerMile =
                          chartData.ratePerMile[dataPointIndex];

                        // Get the actual data point for additional info
                        const dataPoint = historicalRatesData.sort(
                          (a, b) =>
                            new Date(a.actualDeliveryDate) -
                            new Date(b.actualDeliveryDate)
                        )[dataPointIndex];

                        return `
                <div class="apexcharts-tooltip-box" style="padding: 12px; background: white; border-radius: 6px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); min-width: 250px;">
                  <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px; color: #333;">${carrierName}</div>
                  <div style="font-size: 12px; color: #666; margin-bottom: 12px;">
                    <div>Delivery Date: ${date}</div>
                    <div>Quote Date: ${quoteDate}</div>
                    <div>Service: ${serviceType}</div>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div>
                      <div style="font-size: 11px; color: #666;">Quote Value</div>
                      <div style="font-size: 16px; font-weight: bold; color: #1976d2;">$${formatNumberWithCommas(quoteValue)}</div>
                    </div>
                    ${
                      ratePerMile > 0
                        ? `
                    <div style="text-align: right;">
                      <div style="font-size: 11px; color: #666;">Rate per mile</div>
                      <div style="font-size: 14px; font-weight: bold; color: #4caf50;">$${ratePerMile.toFixed(2)}/mile</div>
                    </div>
                    `
                        : ''
                    }
                  </div>
                </div>
              `;
                      }
                    },
                    legend: {
                      position: 'top',
                      horizontalAlign: 'right',
                      fontSize: '12px',
                      markers: {
                        radius: 12
                      }
                    },
                    grid: {
                      borderColor: '#f1f1f1',
                      strokeDashArray: 3
                    }
                  };

                  return (
                    <ReactApexChart
                      options={chartOptions}
                      series={chartOptions.series}
                      type='line'
                      height={350}
                    />
                  );
                })()}
              </Box>

              {/* Detailed Rate Table */}
              <Typography
                variant='subtitle2'
                gutterBottom
                sx={{ mt: 3, mb: 2 }}
              >
                Rate History Details
              </Typography>
              <Grid container spacing={2}>
                {historicalRatesData
                  .sort(
                    (a, b) =>
                      new Date(b.actualDeliveryDate) -
                      new Date(a.actualDeliveryDate)
                  )
                  .map((rate, index) => (
                    <Grid item xs={12} key={index}>
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderLeft: '4px solid',
                          borderLeftColor: rate.isCurrent
                            ? 'primary.main'
                            : 'grey.300',
                          transition: 'all 0.2s',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                          }
                        }}
                      >
                        <Grid container spacing={2} alignItems='center'>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='caption' color='textSecondary'>
                              Delivery Date
                            </Typography>
                            <Typography variant='body1'>
                              {rate.actualDeliveryDate
                                ? new Date(
                                    rate.actualDeliveryDate
                                  ).toLocaleDateString()
                                : 'Not delivered'}
                            </Typography>
                            <Typography
                              variant='caption'
                              color='textSecondary'
                              sx={{ display: 'block' }}
                            >
                              Quote:{' '}
                              {new Date(rate.createdOn).toLocaleDateString()}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='caption' color='textSecondary'>
                              Carrier
                            </Typography>
                            <Typography
                              variant='body1'
                              sx={{ fontWeight: 500 }}
                            >
                              {rate.carrierName}
                            </Typography>
                            {rate.serviceType && (
                              <Typography
                                variant='caption'
                                color='textSecondary'
                              >
                                Service: {rate.serviceType}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='caption' color='textSecondary'>
                              Quote Value
                            </Typography>
                            <Typography
                              variant='h6'
                              color='primary'
                              sx={{ fontWeight: 'bold' }}
                            >
                              $
                              {formatNumberWithCommas(rate.quoteNetCharge || 0)}
                            </Typography>
                          </Grid>
                          {/* <Grid item xs={12} sm={3}>
                            <Box
                              display='flex'
                              justifyContent='flex-end'
                              alignItems='center'
                              gap={1}
                            >
                              {rate.shipmentMiles && rate.quoteNetCharge && (
                                <Chip
                                  label={`$${(rate.quoteNetCharge / rate.shipmentMiles).toFixed(2)}/mile`}
                                  size='small'
                                  color='success'
                                  variant='outlined'
                                />
                              )}
                              {rate.isCurrent && (
                                <Chip
                                  label='Current'
                                  color='primary'
                                  size='small'
                                />
                              )}
                            </Box>
                          </Grid> */}
                        </Grid>
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          ) : (
            <Box textAlign='center' p={3}>
              <HistoryIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
              <Typography color='textSecondary'>
                No historical rates found for this carrier
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistoricalRates}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={cancelShipDialog}
        onClose={handleClose}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Cancel Shipment</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin='dense'
            label='Reason for cancellation'
            type='text'
            fullWidth
            variant='outlined'
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            size='small'
            onClick={handleClose}
            color='inherit'
          >
            Back
          </Button>
          <Button
            size='small'
            onClick={handleConfirm}
            color='error'
            variant='contained'
            disabled={cancelShipLoad}
          >
            Confirm Cancel{' '}
            {cancelShipLoad && <CircularProgress sx={{ ml: 1 }} size={15} />}
          </Button>
        </DialogActions>
      </Dialog>

      {openChats && (
        <Box>
          <FloatingChatSystem
            chatOrder={chatOrder}
            handleMarkAsReadMsgs={handleMarkAsReadMsgs}
            openChats={openChats}
            chatMinimized={chatMinimized}
            setChatMinimized={setChatMinimized}
            toggleChatMinimize={toggleChatMinimize}
            handleOpenChat={handleOpenChat}
            shipperSessionId={shipperSessionId}
            chatData={carrierApiMsgs}
            ratingCarriers={sortedItems.filter(
              carrier =>
                carrier?.carrierResponseStatus?.toUpperCase() !== 'PENDING'
            )}
            shipperApiMsgs={shipperApiMsgs}
            handleShowUserInputMsgs={handleShowUserInputMsgs}
            handleKeyDown={handleKeyDown}
            handleUserInput={handleUserInput}
            userInput={userInput}
          />
        </Box>
      )}
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          borderRadius: 2,
          p: 1,
          my: 1,
          width: '99%',
          border: '1px solid',
          borderColor: 'grey.300',
          backgroundColor: lightBlue[50],
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease',
          '&:hover': {
            borderColor: 'grey.500',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }
        }}
        gap={0}
      >
        {/* <Grid
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography variant='h5' sx={{ fontWeight: 500, fontSize: 16 }}>
            Carrier Selection
          </Typography>
          <Typography variant='body1' sx={{ fontSize: 14 }}>
            Select one or multiple carriers that offer{' '}
            {previousRowDetails?.equipmentType} for your shipment
          </Typography>
        </Grid> */}
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h5' sx={{ fontWeight: 500, fontSize: 16 }}>
              Pickup Mode
            </Typography>
            <Typography variant='body1' sx={{ fontSize: 14 }}>
              {quoteMode}
            </Typography>
          </Grid>

          <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h5' sx={{ fontWeight: 500, fontSize: 16 }}>
              Equipment Type
            </Typography>
            <Typography variant='body1' sx={{ fontSize: 14 }}>
              {previousRowDetails?.equipmentType}{' '}
              {previousRowDetails?.equipmentType === 'Reefer' &&
                `(${previousRowDetails?.temperature}${
                  previousRowDetails?.unit
                    ? previousRowDetails?.unit
                    : previousRowDetails?.temperatureUnit
                })`}
            </Typography>
          </Grid>

          <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h5' sx={{ fontWeight: 500, fontSize: 16 }}>
              Driver Type
            </Typography>
            <Typography variant='body1' sx={{ fontSize: 14 }}>
              {previousRowDetails?.serviceType}
            </Typography>
          </Grid>

          <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h5' sx={{ fontWeight: 500, fontSize: 16 }}>
              Quotation Number
            </Typography>
            <Typography variant='body1' sx={{ fontSize: 14 }}>
              {quoteNumber}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        gap={3}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{ display: 'flex', m: 0 }}
      >
        <Grid
          className='scroll'
          item
          sm={5.7}
          md={5.7}
          lg={5.7}
          xl={5.7}
          sx={{
            height: '70vh',
            borderRadius: 2,
            p: 1,
            border: '1px solid',
            borderColor: 'grey.300', // light grey from MUI theme
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderColor: 'grey.500',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
            }
          }}
        >
          <Row>
            <Grid
              sx={{
                mt: 0,
                mb: 1,
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
              gap={2}
            >
              <Typography sx={{ fontSize: 16, fontWeight: 500 }} variant='h5'>
                Available {previousRowDetails?.equipmentType} Carriers
              </Typography>

              <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                {carriers.length > 1 && !disableQuoteBtn && (
                  <Button
                    disabled={
                      sendQuoteToAll || shipStatus === 'Booked' || isLoading
                    }
                    onClick={e => {
                      e.stopPropagation();
                      handleResendQuote(sortedItems, 'sendToAll');
                    }}
                    color={'warning'}
                    sx={{
                      width: 170,
                      mr: 2,
                      borderRadius: 5,
                      fontSize: 10,
                      textTransform: 'capitalize'
                    }}
                    variant='contained'
                    size='small'
                  >
                    Send Quote to All Carriers{' '}
                    {sendQuoteToAll && (
                      <CircularProgress sx={{ ml: 1 }} size={15} />
                    )}
                  </Button>
                )}
                <Typography variant='body1'>Filter by:</Typography>{' '}
                <Autocomplete
                  freeSolo
                  forcePopupIcon={true}
                  options={carrierOptions}
                  value={searchCarrier}
                  inputValue={searchCarrier}
                  onInputChange={(event, newInputValue) => {
                    setSearchCarrier(newInputValue);
                  }}
                  disableClearable
                  popupIcon={<ExpandMoreIcon />}
                  renderInput={params => (
                    <TextField
                      {...params}
                      size='small'
                      placeholder='Search carriers...'
                      variant='outlined'
                      sx={{
                        ml: 1,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        width: 200
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: params.InputProps.endAdornment
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: 40,
                mx: 1,
                width: '98%',
                borderRadius: 2,
                backgroundColor: grey[200]
              }}
            >
              <div
                style={
                  isMobile
                    ? {
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'center'
                        // marginLeft: 1
                      }
                    : {
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'center'
                      }
                }
              >
                {' '}
                <Box
                  className='d-flex'
                  sx={{ alignItems: 'center', m: 0, p: 0 }}
                >
                  <Typography
                    variant='h6'
                    className='fw-bold text-black me-2'
                    style={{ cursor: 'pointer', fontSize: '13px' }}
                    onClick={handleSortToggle}
                  >
                    {sortOrder === 'ASC' ? (
                      <SortIcon
                        style={{
                          transform: 'rotateX(180deg)',
                          fontSize: '16px'
                        }}
                      />
                    ) : (
                      <SortIcon style={{ fontSize: '16px' }} />
                    )}{' '}
                    Sort
                  </Typography>
                  <Tabs
                    onChange={handleSortValueChange}
                    value={sortValue}
                    aria-label='Tabs where selection follows focus'
                    selectionFollowsFocus
                  >
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label='Price'
                      onClick={() => setSortKey('price')}
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label='Dates'
                      onClick={() => setSortKey('days')}
                    />
                    <Tab
                      sx={{
                        fontSize: '13px',
                        minWidth: 'auto',
                        textTransform: 'none'
                      }}
                      className='px-2 fw-bold'
                      iconPosition='start'
                      label={
                        sortOrder === 'ASC' ? 'Carrier A-Z' : 'Carrier Z-A'
                      }
                      onClick={() => setSortKey('name')}
                    />
                  </Tabs>
                </Box>
              </div>
              {sortedItems.filter(item => !item.isPublic).length > 1 &&
                carriers.length > 2 &&
                !disableQuoteBtn && (
                  <Button
                    disabled={
                      sendQuoteToAll || shipStatus === 'Booked' || isLoading
                    }
                    onClick={e => {
                      e.stopPropagation();
                      handleShareRatesWithWysis(sortedItems);
                      // handleResendQuote(sortedItems, 'sendToAll');
                    }}
                    color='success'
                    sx={{
                      width: 100,
                      mr: 2,
                      borderRadius: 5,
                      fontSize: 10,
                      textTransform: 'capitalize'
                    }}
                    variant='contained'
                    size='small'
                  >
                    Share all rates{' '}
                    {sendQuoteToAll && (
                      <CircularProgress sx={{ ml: 1 }} size={15} />
                    )}
                  </Button>
                )}
              {!isLoading && (
                <Typography
                  variant='body1'
                  className='px-2 fw-bold'
                  sx={{
                    fontSize: '13px',
                    minWidth: 'auto',
                    textTransform: 'none'
                  }}
                >
                  {totalResponded} / {carriers.length} Carriers Rated
                </Typography>
              )}
            </Grid>

            <Grid
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                height: 40,
                mx: 1
                // mt: 1
                // width: '98%',
                // borderRadius: 2,
                // backgroundColor: grey[100]
              }}
            >
              {/* <Typography
                variant='body1'
                sx={{ fontSize: 14, fontWeight: 500, ml: 2 }}
              >
                View historical rates for carriers
              </Typography> */}

              <Button
                variant='outlined'
                size='small'
                endIcon={
                  loadingHistoricalRates ? (
                    <CircularProgress size={16} />
                  ) : (
                    <IconButton
                      size='small'
                      // onClick={e => handleOpenHistoricalRates(e, 'items')}
                      // disabled={loadingHistoricalRates}
                      sx={{
                        background:
                          'linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)',
                        color: 'white',
                        boxShadow: '0 3px 10px rgba(255, 107, 107, 0.4)',
                        maxWidth: '28px',
                        maxHeight: '28px',
                        border: '2px solid white',
                        '&:hover': {
                          background:
                            'linear-gradient(45deg, #FF5252 30%, #FF7B47 90%)',
                          boxShadow: '0 4px 15px rgba(255, 107, 107, 0.6)',
                          transform: 'scale(1.05)',
                          transition: 'all 0.2s ease-in-out'
                        },
                        '&:active': {
                          transform: 'scale(0.95)'
                        }
                      }}
                    >
                      <HistoryIcon fontSize='small' />
                    </IconButton>
                  )
                }
                onClick={e => handleOpenHistoricalRates(e, 'items')}
                disabled={loadingHistoricalRates}
                sx={{
                  mr: 1,
                  borderRadius: 4,
                  textTransform: 'none',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  borderColor: 'primary.main',
                  color: 'primary.main',
                  '&:hover': {
                    backgroundColor: 'primary.50',
                    borderColor: 'primary.dark'
                  }
                }}
              >
                View Historical Rates
              </Button>
            </Grid>

            {/* <hr /> */}
            <Grid
              sx={{
                height: '55vh',
                overflowX: 'scroll',
                overflowY: 'scroll'
              }}
              // xl={negotitateRate ? 7 : 12}
              // lg={negotitateRate ? 7 : 12}
            >
              <div>
                {isLoading
                  ? [1, 2, 3, 4, 5].map(items => (
                      <div
                        style={
                          isMobile
                            ? { margin: '13px 1px 0px 1px' }
                            : { margin: '20px' }
                        }
                        className={'List_Carrier_div'}
                      >
                        <Row
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <div
                            style={
                              isLoading
                                ? {
                                    width: 60,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    position: 'absolute',
                                    margin: '-90 0 0 20',
                                    backgroundColor: 'white',
                                    whiteSpace: 'nowrap'
                                  }
                                : {
                                    width: 'auto',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    position: 'absolute',
                                    margin: '-90 0 0 20',
                                    backgroundColor: 'white',
                                    whiteSpace: 'nowrap'
                                  }
                            }
                          ></div>
                          <Col>
                            <Box
                              sx={{
                                height: 60,
                                margin: '20 0 0 17'
                              }}
                            >
                              <Skeleton
                                variant='circular'
                                width={isMobile ? 30 : 40}
                                height={isMobile ? 30 : 40}
                              />
                            </Box>
                          </Col>
                          <Col>
                            <div style={{ cursor: 'pointer' }}>
                              <h2>
                                <Box
                                  sx={isMobile ? { width: 40 } : { width: 120 }}
                                >
                                  <Skeleton />
                                </Box>
                              </h2>

                              <span
                                style={{
                                  width: 'auto',
                                  fontSize: 10,
                                  fontWeight: 700,
                                  position: 'absolute',
                                  margin: '-14 0 0 0',
                                  cursor: 'auto'
                                }}
                              >
                                <Box
                                  sx={
                                    isMobile
                                      ? { width: 50, marginTop: 0.5 }
                                      : { width: 100, marginTop: 0.5 }
                                  }
                                >
                                  <Skeleton />
                                </Box>
                              </span>
                            </div>
                          </Col>
                          <Col>
                            <div
                              style={{
                                display: 'flex',
                                marginTop: 15
                              }}
                            >
                              <div>
                                <span
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700
                                  }}
                                >
                                  <Box
                                    sx={
                                      isMobile ? { width: 40 } : { width: 110 }
                                    }
                                  >
                                    <Skeleton />
                                  </Box>
                                  <br />
                                  <span
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 'normal'
                                    }}
                                  >
                                    <Box
                                      sx={
                                        isMobile
                                          ? { width: 30, marginTop: -2 }
                                          : { width: 80, marginTop: -2 }
                                      }
                                    >
                                      <Skeleton />
                                    </Box>
                                  </span>
                                </span>
                              </div>{' '}
                            </div>
                          </Col>
                          <Col>
                            <div
                              style={{
                                display: 'flex',
                                marginTop: 15
                              }}
                            >
                              <div>
                                <span
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700
                                  }}
                                >
                                  <Box
                                    sx={
                                      isMobile ? { width: 40 } : { width: 110 }
                                    }
                                  >
                                    <Skeleton />
                                  </Box>
                                  <br />
                                  <span
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 'normal'
                                    }}
                                  >
                                    <Box
                                      sx={
                                        isMobile
                                          ? { width: 30, marginTop: -2 }
                                          : { width: 80, marginTop: -2 }
                                      }
                                    >
                                      <Skeleton />
                                    </Box>
                                  </span>
                                </span>
                              </div>{' '}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  : sortedItems.map((items, index) => {
                      if (items) {
                        return (
                          <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <List>
                                <ListItemButton
                                  disabled={
                                    shipStatus === 'Booked' &&
                                    items?.carrierResponseStatus?.toLowerCase() !==
                                      'accepted'
                                  }
                                  onMouseDown={handleClick}
                                  selected={selectedIndex === index}
                                  onClick={event => {
                                    setSelectCarrier(items);
                                    handleListItemClick(event, index, items);
                                  }}
                                >
                                  <Grid
                                    key={index}
                                    className='Carrier_div'
                                    style={
                                      isMobile
                                        ? {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            fontSize: 10
                                          }
                                        : {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            height: '100px'
                                          }
                                    }
                                  >
                                    <Grid container>
                                      <Grid container>
                                        <Grid
                                          item
                                          xs={2.5}
                                          sm={2.5}
                                          md={2.5}
                                          lg={2.5}
                                          xl={2.5}
                                        >
                                          <Avatar
                                            variant='rounded'
                                            style={
                                              isMobile
                                                ? {
                                                    height: 50,
                                                    width: '50',
                                                    objectFit: 'contain'
                                                  }
                                                : {
                                                    marginLeft: '5%',
                                                    height: 70,
                                                    width: '70',
                                                    objectFit: 'contain'
                                                  }
                                            }
                                            src={
                                              items.carrierLogo
                                                ? base_logo_url +
                                                  items.carrierLogo
                                                : NoLogo
                                            }
                                            alt={''}
                                          />
                                        </Grid>

                                        <Grid
                                          item
                                          xs={2.5}
                                          sm={2.5}
                                          md={2.5}
                                          lg={2.5}
                                          xl={2.5}
                                        >
                                          {isMobile ? (
                                            <Typography>
                                              {items.carrierName}
                                            </Typography>
                                          ) : (
                                            <Typography
                                              variant='h5'
                                              sx={{
                                                fontWeight: 'bold',
                                                fontSize: 18
                                              }}
                                            >
                                              {items.carrierName}
                                            </Typography>
                                          )}
                                          <Typography
                                            variant='caption'
                                            color={'grey'}
                                          >
                                            Service Level
                                          </Typography>
                                          <br />
                                          <Typography
                                            variant='caption'
                                            sx={{ fontWeight: 'bold' }}
                                          >
                                            {previousRowDetails?.serviceType}
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          sx={{ mt: 2 }}
                                          xs={3.5}
                                          sm={3.5}
                                          md={3.5}
                                          lg={3.5}
                                          xl={3.5}
                                        >
                                          {isMobile ? (
                                            <Typography
                                              variant='body1'
                                              color={'grey'}
                                            >
                                              Pickup Date
                                            </Typography>
                                          ) : (
                                            <Typography
                                              sx={{ fontSize: 13 }}
                                              variant='body1'
                                              color={'grey'}
                                            >
                                              Pickup Date
                                            </Typography>
                                          )}
                                          {isMobile && <br />}

                                          {
                                            <Typography
                                              sx={{ fontWeight: 500 }}
                                            >
                                              {items?.carrierResponseStatus?.toLowerCase() ===
                                                'responded' ||
                                              items?.carrierResponseStatus?.toLowerCase() ===
                                                'accepted'
                                                ? items?.quotePickupDate
                                                : 'PENDING'}
                                            </Typography>
                                          }
                                        </Grid>
                                        <Grid
                                          item
                                          sx={{ mt: 2 }}
                                          xs={3.5}
                                          sm={3.5}
                                          md={3.5}
                                          lg={3.5}
                                          xl={3.5}
                                        >
                                          {isMobile ? (
                                            <Typography
                                              sx={{ fontSize: 13 }}
                                              variant='body1'
                                              color={'grey'}
                                            >
                                              Estimated Delivery
                                            </Typography>
                                          ) : (
                                            <Typography
                                              sx={{ fontSize: 13 }}
                                              variant='body1'
                                              color={'grey'}
                                            >
                                              Estimated Delivery
                                            </Typography>
                                          )}
                                          {isMobile && <br />}
                                          <Typography sx={{ fontWeight: 500 }}>
                                            {items?.carrierResponseStatus?.toLowerCase() ===
                                              'responded' ||
                                            items?.carrierResponseStatus?.toLowerCase() ===
                                              'accepted'
                                              ? items?.deliveryDate
                                              : 'PENDING'}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      {/* <Grid container sx={{ mt: 1, ml: 3 }}> */}

                                      {/* </Grid> */}
                                    </Grid>
                                    <Grid
                                      sx={{ m: 2 }}
                                      xs={3.5}
                                      sm={3.5}
                                      md={3.5}
                                      lg={3.5}
                                      xl={3.5}
                                    >
                                      <Grid
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'space-between',
                                          alignItems: 'end'
                                        }}
                                      >
                                        <Grid sx={{ my: 1 }}>
                                          {isMobile ? (
                                            <Typography variant='body2'>
                                              {items?.carrierResponseStatus?.toLowerCase() ===
                                                'responded' ||
                                              items?.carrierResponseStatus?.toLowerCase() ===
                                                'accepted'
                                                ? `$${items?.quoteValue}`
                                                : 'PENDING'}
                                            </Typography>
                                          ) : (
                                            <Grid
                                              sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-end',
                                                alignItems: 'flex-end'
                                              }}
                                            >
                                              <Typography
                                                variant='h5'
                                                sx={{
                                                  fontWeight: 'bold',
                                                  fontSize: 18
                                                }}
                                              >
                                                {(items?.carrierResponseStatus?.toLowerCase() ===
                                                  'responded' ||
                                                  items?.carrierResponseStatus?.toLowerCase() ===
                                                    'accepted') &&
                                                  selectedIndex === index && (
                                                    <Verified
                                                      sx={{
                                                        color: 'green',
                                                        fontSize: 28
                                                      }}
                                                    />
                                                  )}
                                                {items?.carrierResponseStatus?.toLowerCase() ===
                                                  'responded' ||
                                                items?.carrierResponseStatus?.toLowerCase() ===
                                                  'accepted'
                                                  ? `$${
                                                      items?.quoteValue &&
                                                      formatNumberWithCommas(
                                                        items?.quoteValue
                                                      )
                                                    }`
                                                  : 'PENDING'}
                                                {(items?.carrierResponseStatus?.toLowerCase() ===
                                                  'responded' ||
                                                  items?.carrierResponseStatus?.toLowerCase() ===
                                                    'accepted') && (
                                                  <Tooltip
                                                    arrow
                                                    placement='right'
                                                    title='View Historical Rates'
                                                  >
                                                    <IconButton
                                                      size='small'
                                                      onClick={e =>
                                                        handleOpenHistoricalRates(
                                                          e,
                                                          items
                                                        )
                                                      }
                                                      disabled={
                                                        loadingHistoricalRates
                                                      }
                                                      sx={{
                                                        background:
                                                          'linear-gradient(45deg, #FF6B6B 30%, #FF8E53 90%)',
                                                        color: 'white',
                                                        boxShadow:
                                                          '0 3px 10px rgba(255, 107, 107, 0.4)',
                                                        maxWidth: '28px',
                                                        maxHeight: '28px',
                                                        border:
                                                          '2px solid white',
                                                        '&:hover': {
                                                          background:
                                                            'linear-gradient(45deg, #FF5252 30%, #FF7B47 90%)',
                                                          boxShadow:
                                                            '0 4px 15px rgba(255, 107, 107, 0.6)',
                                                          transform:
                                                            'scale(1.05)',
                                                          transition:
                                                            'all 0.2s ease-in-out'
                                                        },
                                                        '&:active': {
                                                          transform:
                                                            'scale(0.95)'
                                                        }
                                                      }}
                                                    >
                                                      {loadingHistoricalRates ? (
                                                        <CircularProgress
                                                          size={20}
                                                          sx={{
                                                            color: 'white'
                                                          }}
                                                        />
                                                      ) : (
                                                        <HistoryIcon fontSize='small' />
                                                      )}
                                                    </IconButton>
                                                  </Tooltip>
                                                )}
                                              </Typography>

                                              {distanceMiles !== 0 &&
                                                (items?.carrierResponseStatus?.toLowerCase() ===
                                                  'responded' ||
                                                  items?.carrierResponseStatus?.toLowerCase() ===
                                                    'accepted') && (
                                                  <Typography
                                                    variant='caption'
                                                    color={'grey'}
                                                  >
                                                    $
                                                    {calculateRatePerMile(
                                                      distanceMiles,
                                                      items?.quoteValue
                                                    )}
                                                    /mile
                                                  </Typography>
                                                )}
                                            </Grid>
                                          )}
                                        </Grid>

                                        <Grid
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            gap: 1
                                          }}
                                        >
                                          {!items?.isPublic ? (
                                            <Button
                                              color='success'
                                              onClick={e => {
                                                e.stopPropagation();
                                                handleShareRatesWithWysis(
                                                  items
                                                );
                                              }}
                                              sx={{
                                                width: '5vw',
                                                borderRadius: 5,
                                                fontSize: 10,
                                                textTransform: 'capitalize'
                                              }}
                                              variant='contained'
                                              size='small'
                                            >
                                              Share Rate
                                            </Button>
                                          ) : (
                                            <Chip
                                              label='Rate Shared'
                                              size='small'
                                              icon={
                                                <Verified
                                                  sx={{
                                                    fontSize: 14,
                                                    color: '#fff !important'
                                                  }}
                                                />
                                              }
                                              sx={{
                                                backgroundColor: '#2e7d32 !important',
                                                color: '#fff !important',
                                                fontWeight: 600,
                                                fontSize: 10,
                                                opacity: 0.75,
                                                cursor: 'default',
                                                pointerEvents: 'none'
                                              }}
                                            />
                                          )}
                                          {items?.carrierResponseStatus?.toLowerCase() ===
                                            'accepted' &&
                                            shipStatus === 'Booked' && (
                                              <Button
                                                disabled={cancelShipLoad}
                                                color={'error'}
                                                onClick={e => {
                                                  e.stopPropagation();
                                                  handleCancelShip(e, items);
                                                }}
                                                sx={{
                                                  width: '6vw',
                                                  mr: 2,
                                                  borderRadius: 5,
                                                  fontSize: 10,
                                                  textTransform: 'capitalize'
                                                }}
                                                variant='contained'
                                                size='small'
                                              >
                                                Cancel Shipment{' '}
                                                {cancelShipLoad && (
                                                  <CircularProgress
                                                    sx={{ ml: 1 }}
                                                    size={15}
                                                  />
                                                )}
                                              </Button>
                                            )}
                                          {items?.carrierResponseStatus?.toLowerCase() ===
                                            'responded' &&
                                            shipStatus === 'Cancelled' && (
                                              <Button
                                                onClick={e => {
                                                  e.stopPropagation();
                                                  handleNegotiateRate(
                                                    e,
                                                    items,
                                                    'Resend'
                                                  );
                                                }}
                                                color={'primary'}
                                                sx={{
                                                  width: 110,
                                                  mr: 2,
                                                  borderRadius: 5,
                                                  fontSize: 10,
                                                  textTransform: 'capitalize'
                                                }}
                                                variant='contained'
                                                size='small'
                                              >
                                                Re-Quote
                                              </Button>
                                            )}

                                          <Box
                                            position='relative'
                                            display='inline-block'
                                          >
                                            {/* Show animated dot only for responded or accepted */}
                                            {(items?.carrierResponseStatus?.toLowerCase() ===
                                              'responded' ||
                                              items?.carrierResponseStatus?.toLowerCase() ===
                                                'accepted') &&
                                              (items?.chatDetails ?? []).filter(
                                                m =>
                                                  m.actionByFlag ===
                                                    'CARRIER' &&
                                                  m.isRead === false
                                              ).length > 0 && (
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    position: 'absolute',
                                                    top: -5,
                                                    right: 4,
                                                    width: 12,
                                                    height: 12,
                                                    fontSize: 12,
                                                    borderRadius: '50%',
                                                    color: 'white',
                                                    backgroundColor: '#81c784',
                                                    boxShadow:
                                                      '0 0 0 0 #81c784',
                                                    animation:
                                                      'pulse 1.6s infinite ease-in-out',
                                                    zIndex: 1,
                                                    '@keyframes pulse': {
                                                      '0%': {
                                                        transform: 'scale(1)',
                                                        boxShadow:
                                                          '0 0 0 0 rgba(129, 199, 132, 0.7)'
                                                      },
                                                      '70%': {
                                                        transform: 'scale(1.4)',
                                                        boxShadow:
                                                          '0 0 0 6px rgba(129, 199, 132, 0)'
                                                      },
                                                      '100%': {
                                                        transform: 'scale(1)',
                                                        boxShadow:
                                                          '0 0 0 0 rgba(129, 199, 132, 0)'
                                                      }
                                                    }
                                                  }}
                                                >
                                                  <span>
                                                    {
                                                      (
                                                        items?.chatDetails ?? []
                                                      ).filter(
                                                        m =>
                                                          m.actionByFlag ===
                                                            'CARRIER' &&
                                                          m.isRead === false
                                                      ).length
                                                    }
                                                  </span>
                                                </Box>
                                              )}

                                            <Button
                                              color={
                                                items?.carrierResponseStatus?.toLowerCase() ===
                                                  'responded' ||
                                                items?.carrierResponseStatus?.toLowerCase() ===
                                                  'accepted'
                                                  ? 'success'
                                                  : 'primary'
                                              }
                                              onClick={e => {
                                                e.stopPropagation();
                                                handleOpenChat(
                                                  items.sessionId,
                                                  true,
                                                  items
                                                );
                                                handleNegotiateRate(
                                                  e,
                                                  items,
                                                  items?.carrierResponseStatus?.toLowerCase() ===
                                                    'responded' ||
                                                    items?.carrierResponseStatus?.toLowerCase() ===
                                                      'accepted'
                                                    ? 'Chat'
                                                    : 'Resend'
                                                );
                                              }}
                                              sx={{
                                                borderRadius: 5,
                                                fontSize: 10,
                                                textTransform: 'capitalize'
                                              }}
                                              variant='contained'
                                              size='small'
                                            >
                                              {items?.carrierResponseStatus?.toLowerCase() ===
                                                'responded' ||
                                              items?.carrierResponseStatus?.toLowerCase() ===
                                                'accepted'
                                                ? 'Chat'
                                                : 'Resend'}
                                            </Button>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </ListItemButton>
                              </List>
                            </Grid>
                          </Grid>
                        );
                      }
                    })}

                {ApiFailed && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '10%'
                    }}
                  >
                    {/* <div class='alert alert-danger' role='alert'>
                  {ApiErrorMessage}
                </div> */}
                    <Alert severity='error'>{ApiErrorMessage}</Alert>
                  </div>
                )}
              </div>
            </Grid>
          </Row>
        </Grid>

        <Grid
          item
          sx={{
            height: '70vh',
            overflowX: 'hidden',
            overflowY: 'auto',
            borderRadius: 2,
            p: 1,
            border: '1px solid',
            borderColor: 'grey.300',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.3s ease',
            backgroundColor: 'white',
            '&:hover': {
              borderColor: 'grey.500',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
            }
          }}
          lg={6}
          xl={6}
        >
          {/* <b style={{ color: '#2563eb', fontSize: 14 }}>Shipment Details</b> */}

          <Grid
            container
            sx={{
              mt: 1,
              backgroundColor: '#EEF4FC',
              p: 1,
              borderRadius: 2
            }}
            // spacing={2}
          >
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: 'flex',
                justifyContent: 'space-between'
                // gap: 1
              }}
            >
              <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                <div className='rating_scree_label'>Total Net Weight (lbs)</div>
                <div className='rating_scree_value'>
                  {formatNumberWithCommas(previousRowDetails?.totalNetWeight)}
                </div>
              </Grid>

              <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                <div className='rating_scree_label'>
                  Total Gross Weight (lbs)
                </div>
                <div className='rating_scree_value'>
                  {formatNumberWithCommas(previousRowDetails?.totalGrossWeight)}
                </div>
              </Grid>

              <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                <div className='rating_scree_label'>Total # of Units</div>
                <div className='rating_scree_value'>{totalPieces}</div>
              </Grid>
            </Grid>
          </Grid>

          {/* <Divider sx={{ my: 1 }} /> */}
          {shipmentsDetails.length > 0 && (
            <ShipmentDetailsComponent
              shipmentsDetails={shipmentsDetails}
              groupedPickupDetails={groupedPickupDetails}
              groupedDeliveryDetails={groupedDeliveryDetails}
              previousRowDetails={previousRowDetails}
              quoteMode={quoteMode}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TLRatingScreen;
